export const NOTIFICATION = {
  LATESTNOTIFICATION: 'latest_notification',
  NOTICE_LIST: 'notice_list',
  NOTICE_WRITERS: 'notice_writers',
  NOTICE_ACCESS: 'notice_access',
};
